import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Kinetic mask reveal — line by line
export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <span className="mask-line">
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay }}
      className={`inline-block will-change-transform ${className}`}
      style={{ display: "inline-block" }}
    >
      {children}
    </motion.span>
  </span>
);

// Section reveal (scroll triggered) — fade + subtle rise
export const SectionReveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1], delay }}
    className={className}
  >
    {children}
  </motion.div>
);

// Word stagger reveal — always plays on mount (guaranteed visible)
export const StaggerWords = ({ text, className = "", delay = 0 }) => {
  const words = text.split(" ");
  return (
    <span className={className}>
      {words.map((w, i) => (
        <span key={i} className="mask-line" style={{ display: "inline-block", marginRight: "0.22em" }}>
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.05 }}
            style={{ display: "inline-block" }}
          >
            {w}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Parallax image wrapper
export const ParallaxImage = ({ src, alt, className = "", strength = 80 }) => {
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-strength, strength]);
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className="w-full h-full object-contain object-center"
        loading="lazy"
      />
    </div>
  );
};
